export default "__VITE_ASSET__DxLsb0Ro__"